import type * as React from 'react'

interface Props<T> {
  if: T
  then: React.JSX.Element | ((value: NonNullable<T>) => React.JSX.Element)
  fallback?: React.JSX.Element | null
}

export function Conditional<T>({ fallback = null, if: value, then }: Props<T>) {
  const element = typeof then == 'function' ? then(value!) : then

  return value ? element : fallback
}
